import Vue from "vue";
import Credentials from "@/services/Credentials.service.js";

const credentials = new Credentials();
// Added Interceptors
Vue.http.interceptors.push(function(request, next) {
  request.headers.set("Authorization", credentials.getToken());
  request.headers.set("Accept", "application/json");
  next(function(response) {
    if (
      response.status === 401 &&
      window.location.href !== process.env.address.spa
    ) {
      credentials.clearCredentials();
      if (!window.location.pathname.includes("auth")) {
        window.location.reload();
      }
    }

    // Laravel Request Errors
    if (response.body.errors) {
      const keys = Object.keys(response.body.errors);
      const firstKey = keys[0];
      Vue.swal({
        icon: "error",
        title: `Error`,
        text: response.body.errors[firstKey][0]
      });
    }
  });
});



// WEBPACK FOOTER //
// ./src/services/Api.interceptor.js